// @flow
import {
  type Specification as LoggerSpecification,
  fromSpecification as loggerFromSpecification,
} from './sink/logger';
import {
  type Specification as GTMSpecification,
  fromSpecification as gtmFromSpecification,
} from './sink/google-tag-manager';
import {
  type Specification as GtagsSpecification,
  fromSpecification as gtagsFromSpecification,
} from './sink/google-analytics-gtag';
import {
  type Specification as RudderstackSpecification,
  fromSpecification as rudderstackFromSpecification,
} from './sink/rudderstack';
import type { EventSink } from './event-sink';

// TODO: this doesn't seem to register as a disjoint union for some reason
// export enum SinkType of string {
//  Logger = 'Logger',
//  GoogleTagManager = 'GoogleTagManager',
// }
//
// export type Specification =
//  | ROE<{ type: typeof SinkType.GoogleTagManager, options: GTMSpecification }>
//  | ROE<{ type: typeof SinkType.Logger, options: LoggerSpecification }>;

export const SINK_TYPE_LOGGER: 'SINK_TYPE_LOGGER' = 'SINK_TYPE_LOGGER';
export const SINK_TYPE_GOOGLE_TAG_MANAGER: 'SINK_TYPE_GOOGLE_TAG_MANAGER' =
  'SINK_TYPE_GOOGLE_TAG_MANAGER';
export const SINK_TYPE_GOOGLE_ANALYTICS_GTAG: 'SINK_TYPE_GOOGLE_ANALYTICS_GTAG' =
  'SINK_TYPE_GOOGLE_ANALYTICS_GTAG';
export const SINK_TYPE_RUDDERSTACK: 'SINK_TYPE_RUDDERSTACK' =
  'SINK_TYPE_RUDDERSTACK';

export type Specification =
  | $ReadOnly<{|
      type: typeof SINK_TYPE_GOOGLE_TAG_MANAGER,
      options: GTMSpecification,
    |}>
  | $ReadOnly<{| type: typeof SINK_TYPE_LOGGER, options: LoggerSpecification |}>
  | $ReadOnly<{|
      type: typeof SINK_TYPE_GOOGLE_ANALYTICS_GTAG,
      options: GtagsSpecification,
    |}>
  | $ReadOnly<{|
      type: typeof SINK_TYPE_RUDDERSTACK,
      options: RudderstackSpecification,
    |}>;

export const fromSpecification: (Specification) => EventSink = (
  specification,
) => {
  // eslint-disable-next-line default-case
  switch (specification.type) {
    case SINK_TYPE_LOGGER:
      return loggerFromSpecification(specification.options);
    case SINK_TYPE_GOOGLE_TAG_MANAGER:
      return gtmFromSpecification(specification.options);
    case SINK_TYPE_GOOGLE_ANALYTICS_GTAG:
      return gtagsFromSpecification(specification.options);
    case SINK_TYPE_RUDDERSTACK:
      return rudderstackFromSpecification(specification.options);
    default:
      (specification.type: empty);
      throw new Error(`Unhandled EventSink type: ${specification.type}`);
  }
};
